import { BookingsSummaryReport } from 'model/BookingsReport';

export interface BookingsSummaryReportState {
    summary: BookingsSummaryReport;
    status: BookingsSummaryReportStatus;
    loading: boolean;
}

export enum BookingsSummaryReportStatus {
    Initial,
    Getting,
    GettingSuccess,
    Error
}
